import { cn } from "@/lib/utils";

export const LiveBadge = ({ isLive, className }) => (
  <span
    data-testid="live-status-badge"
    className={cn(
      "inline-flex items-center gap-2 rounded-none border px-3 py-1.5 font-subheading text-xs font-semibold uppercase tracking-widest",
      isLive ? "border-live-red text-live-red" : "border-white/20 text-white/50",
      className
    )}
  >
    <span className={cn("h-2 w-2 rounded-full", isLive ? "bg-live-red animate-pulse" : "bg-white/30")} aria-hidden="true" />
    {isLive ? "Live Now" : "Offline"}
  </span>
);
